import { ApiRequest } from 'app/common/types'

interface EventsGetContent {
  audienceId: string
  fromDate?: string
  toDate?: string
}

export type EventsGetRequest = ApiRequest<EventsGetContent>

export interface EventEntity {
  name: string
  timestamp: string
}

export interface EventsGetResponse {
  data: { events: EventEntity[] }
}

export type Event = {
  name: string
  timestamp: Date
}

const mapEvent = (eventEntity: EventEntity): Event => ({
  name: eventEntity.name,
  timestamp: new Date(eventEntity.timestamp),
})

export const mapEvents = (eventEntities: EventEntity[]): Event[] => eventEntities.map(mapEvent)
